'use client';

import { useEffect } from 'react';
import { useSprdConsent } from '@/atoms/sprdConsentAtom';
import {
  flushErrorQueue,
  loadRaygunScript,
  startPreConsentErrorCapture,
  stopPreConsentErrorCapture,
} from '@/utility/raygun';

type RaygunCrashReportingProps = {
  apiKey?: string;
  version: string;
  enabled: boolean;
  platform?: 'EU' | 'NA';
};

export function RaygunCrashReporting({
  apiKey,
  version,
  enabled,
  platform,
}: RaygunCrashReportingProps) {
  const consent = useSprdConsent();
  const allowed = enabled && !!apiKey && !!consent?.functional;

  useEffect(() => {
    if (!enabled || !apiKey) {
      return;
    }

    // Buffer errors locally (no Raygun CDN) until the user grants functional consent.
    startPreConsentErrorCapture();

    if (!allowed) {
      window.rg4js?.('enableCrashReporting', false);
      return;
    }

    stopPreConsentErrorCapture();
    loadRaygunScript(apiKey, version);
    window.rg4js?.('withTags', [platform ?? 'EU']);
    window.rg4js?.('enableCrashReporting', true);
    window.rg4js?.('options', { ignore3rdPartyErrors: true });
    flushErrorQueue();
  }, [allowed, apiKey, version, enabled, platform]);

  return null;
}
